import { useTranslation } from 'react-i18next';
import type { VendorKpiCategory } from '@/types/vendor-kpi.ts';
import { getScoreColor } from '@/types/vendor-kpi.ts';
import KPIProgressBar from './KPIProgressBar.tsx';

interface KPICategoryCardProps {
  category: VendorKpiCategory;
  teamScore?: number;
}

export default function KPICategoryCard({ category, teamScore }: KPICategoryCardProps) {
  const { t } = useTranslation();
  const color = getScoreColor(category.score);
  const delta = teamScore != null ? category.score - teamScore : null;

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: color }} />
          <h3 className="text-sm font-semibold text-foreground">{category.name}</h3>
        </div>
        <div className="flex items-center gap-2">
          {delta != null && (
            <span
              className={`text-[10px] font-semibold ${
                delta >= 0 ? 'text-green-500' : 'text-red-500'
              }`}
            >
              {delta >= 0 ? '+' : ''}{delta} {t('kpiCard.vsTeam')}
            </span>
          )}
          <span className="text-lg font-extrabold" style={{ color }}>
            {category.score}
          </span>
        </div>
      </div>
      <div className="space-y-2">
        {category.kpis.map((kpi) => (
          <KPIProgressBar
            key={kpi.id}
            label={kpi.label}
            score={kpi.score}
            displayValue={kpi.displayValue}
            size="sm"
          />
        ))}
      </div>
    </div>
  );
}
